export const leadVerificationPoll = (
  url: string,
  onSuccess: () => void,
  delay = 5000
): ReturnType<typeof setInterval> => {
  const interval = setInterval(async () => {
    const result = await fetch(url).then((result) => result.json())

    if (result?.email_verified) {
      clearInterval(interval)
      onSuccess()
    }
  }, delay)
  return interval
}
